import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'


const pageSize = 5;
const pageSizeB = 5;
const pageSizeC = 5;
const pageSizeD = 5;

const OatEducationMain = () => {
  const[pop,setpop] = useState(false);
const token = JSON.parse(localStorage.getItem('usertoken'));
let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
useEffect(()=>{  
   document.getElementById("OatCourseTable").style.display="none"
  getUsers()

   setpop(true);

   setTimeout(() => {
            
    getroleAction() 
    
     }, 1000);
  setTimeout(() => {
          
    setpop(false);
    getAssignedAction()
  
      
     }, 2000);

}, [])
function getroleAction(){


  let LoginRole= localStorage.getItem("Role");
  
 
  console.log('checkrole',LoginRole);
  const body =
  {
    
   role:LoginRole
  }
  console.log('body',body);
 
 
  axios({
         method:"POST",
         url :`${BASE_URL}/oat/GetOatRoleAction`,
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": bearer,
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
     
     
              
        localStorage.setItem("LoginAction",JSON.stringify(response.data))
        localStorage.getItem("LoginAction");
     })
     .catch(error => {
       console.log(error);
 })
 }

 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


    document.getElementById('OatCourseTable').style.display ="block";

   
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('CourseTable-Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('CourseTable-Oat').style.display ="block";
    }
    else{
      document.getElementById('CourseTable-Oat').style.display ="none";

    }
    if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
      document.getElementById('CourseBtn_Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('CourseBtn_Oat').style.display ="block";
    }
    else{
      document.getElementById('CourseBtn_Oat').style.display ="none";

    }


    if( roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="View Table Denied"
    }

    if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="Both View Table and Add Denied"
    }
    
  }

  function getAssignedActionA(){



    ////Admin
      
      let LoginRoleId= localStorage.getItem("RoleId");
  
      let CheckSAdmin = LoginRoleId.includes("00")
      let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
     
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('SpecializationTable-Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('SpecializationTable-Oat').style.display ="block";
      }
      else{
        document.getElementById('SpecializationTable-Oat').style.display ="none";
  
      }

      if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('SpecializationBtn_Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('SpecializationBtn_Oat').style.display ="block";
      }
      else{
        document.getElementById('SpecializationBtn_Oat').style.display ="none";
  
      }

      if( roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="View Table Denied"
      }

      if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="Both View Table and Add Denied"
      }
      
    }

    // const[editiconB,setediticonB] = useState(false);
    function getAssignedActionB(){



      ////Admin
        
        let LoginRoleId= localStorage.getItem("RoleId");
    
        let CheckSAdmin = LoginRoleId.includes("00")
        let CheckAdmin =LoginRoleId.includes("01")
    
    
      /////////////Teammate
        let LoginAction =  localStorage.getItem("LoginAction");
        let TecRoleAction =  JSON.parse(LoginAction);
        let roleAction = TecRoleAction.map((e)=>e.roleAction);
        console.log(roleAction);
        
        let roles = roleAction.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        
        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
    
    
       
    
       
        if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('DegreeTable-Oat').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('DegreeTable-Oat').style.display ="block";
        }
        else{
          document.getElementById('DegreeTable-Oat').style.display ="none";
    
        }

        if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
          document.getElementById('DegreeBtn_Oat').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('DegreeBtn_Oat').style.display ="block";
        }
        else{
          document.getElementById('DegreeBtn_Oat').style.display ="none";
    
        }
    
      

  
        if(roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){
  
          document.getElementById("OatActionDeniedB").innerHTML="View Table Denied"
        }

        if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

          document.getElementById("OatActionDeniedB").innerHTML="Both View Table and Add Denied"
        }
        
      }

      // const[editiconC,setediticonC] = useState(false);
      function getAssignedActionC(){



        ////Admin
          
          let LoginRoleId= localStorage.getItem("RoleId");
      
          let CheckSAdmin = LoginRoleId.includes("00")
          let CheckAdmin =LoginRoleId.includes("01")
      
      
        /////////////Teammate
          let LoginAction =  localStorage.getItem("LoginAction");
          let TecRoleAction =  JSON.parse(LoginAction);
          let roleAction = TecRoleAction.map((e)=>e.roleAction);
          console.log(roleAction);
          
          let roles = roleAction.toString();
          let roleResult = roles.includes('Add')
          console.log(roleResult)
          
          let roleResultA = roles.includes('View')
          console.log(roleResultA)
          
          let roleResultB = roles.includes('Edit')
          console.log(roleResultB)
          
          let roleResultC = roles.includes('Delete')
          console.log(roleResultC)
      
      
         
      
         
          if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
      
            document.getElementById('DegreeLevelTable-Oat').style.display ="block";
          }
          else if(CheckSAdmin==true || CheckAdmin==true){
            document.getElementById('DegreeLevelTable-Oat').style.display ="block";
          }
          else{
            document.getElementById('DegreeLevelTable-Oat').style.display ="none";
      
          }

          if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
            document.getElementById('DegreeLevelBtn_Oat').style.display ="block";
          }
          else if(CheckSAdmin==true || CheckAdmin==true){
            document.getElementById('DegreeLevelBtn_Oat').style.display ="block";
          }
          else{
            document.getElementById('DegreeLevelBtn_Oat').style.display ="none";
      
          }

         
  
    
          if( roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){
    
            document.getElementById("OatActionDeniedC").innerHTML="View Table Denied"
          }

          if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

            document.getElementById("OatActionDeniedC").innerHTML="Both View Table and Add Denied"
          }
          
        }
// GET request using fetch()
const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);



function getUsers(){

    

fetch(`${BASE_URL}/OatMain/GetCourseName`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusers(data);
    setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      }
  );

console.log("check",allusers)


    }

    const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
    // if (pageCount === 1)
    // return null;
    
    const pages = _.range(1, pageCount+1)
    
    const pagination =(pageNo)=>{
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost)
    }

    const onNext = () => {


      pagination(currentPage + 1);
    };
  
    const onPrevious = () => {
      pagination(currentPage - 1);
    };

    
// GET request using fetchB()


const [allusersB, setAllusersB] = useState([])


const [paginatedPostsB, setpaginatedPostsB] = useState();
const [currentPageB, setcurrentPageB] = useState(1);



function getUsersB(){

    

fetch(`${BASE_URL}/OatMain/GetSpecialization`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersB(data);
    setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
      }
  );

console.log("check",allusersB)


    }

    const pageCountB = allusersB? Math.ceil(allusersB.length/pageSizeB) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesB = _.range(1, pageCountB+1)
    
    const paginationB =(pageNoB)=>{
    setcurrentPageB(pageNoB);
    const startIndexB = (pageNoB - 1) * pageSizeB;
    const paginatedPostB = _(allusersB).slice(startIndexB).take(pageSizeB).value();
    setpaginatedPostsB(paginatedPostB)
    }
    const onNextB = () => {


      paginationB(currentPageB + 1);
    };
  
    const onPreviousB = () => {
      paginationB(currentPageB - 1);
    };


    // GET request using fetchC()
const [allusersC, setAllusersC] = useState([])


const [paginatedPostsC, setpaginatedPostsC] = useState();
const [currentPageC, setcurrentPageC] = useState(1);



function getUsersC(){

    

fetch(`${BASE_URL}/OatMain/GetDegree`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersC(data);
    setpaginatedPostsC(_(data).slice(0).take(pageSizeC).value());
      }
  );

console.log("check",allusersC)


    }

    const pageCountC = allusersC? Math.ceil(allusersC.length/pageSizeC) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesC = _.range(1, pageCountC+1)
    
    const paginationC =(pageNoC)=>{
    setcurrentPageC(pageNoC);
    const startIndexC = (pageNoC - 1) * pageSizeC;
    const paginatedPostC = _(allusersC).slice(startIndexC).take(pageSizeC).value();
    setpaginatedPostsC(paginatedPostC)
    }

    const onNextC = () => {


      paginationC(currentPageC + 1);
    };
  
    const onPreviousC = () => {
      paginationC(currentPageC - 1);
    };
// GET request using fetchD()
const [allusersD, setAllusersD] = useState([])


const [paginatedPostsD, setpaginatedPostsD] = useState();
const [currentPageD, setcurrentPageD] = useState(1);



function getUsersD(){

    

fetch(`${BASE_URL}/OatMain/GetDegreeLevel`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersD(data);
    setpaginatedPostsD(_(data).slice(0).take(pageSizeD).value());
      }
  );

console.log("check",allusersD)


    }

    const pageCountD = allusersD? Math.ceil(allusersD.length/pageSizeD) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesD = _.range(1, pageCountD+1)
    
    const paginationD =(pageNoD)=>{
    setcurrentPageD(pageNoD);
    const startIndexD = (pageNoD - 1) * pageSizeD;
    const paginatedPostD = _(allusersD).slice(startIndexD).take(pageSizeD).value();
    setpaginatedPostsD(paginatedPostD)
    }


    const onNextD = () => {


      paginationD(currentPageD + 1);
    };
  
    const onPreviousD = () => {
      paginationD(currentPageD - 1);
    };


  function OpenCoursename(){
    document.getElementById("OatCourseTable").style.display="none"
    getUsers()
    setpop(true);
   
    document.getElementById("OatSpecializationTable").style.display="none"
    document.getElementById("OatDegreeTable").style.display="none"
   document.getElementById("OatDegreeLevelTable").style.display="none"
   document.getElementById("oatCourseBtn").style.background="rgb(249, 249, 249)"
    document.getElementById("oatSpecializationBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatDegreeBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatDegreeLevelBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatCourseBtn").style.color="black"
    document.getElementById("oatSpecializationBtn").style.color="White"
    document.getElementById("oatDegreeBtn").style.color="White"
    document.getElementById("oatDegreeLevelBtn").style.color="White"
    setTimeout(() => {
      setpop(false);  
      getAssignedAction()
      document.getElementById("OatCourseTable").style.display="block"
      
       }, 1000);
  }

  function OpenSpecialization (){
    document.getElementById("OatSpecializationTable").style.display="none"
    getUsersB()
    setpop(true);
    document.getElementById("OatCourseTable").style.display="none"
    
    document.getElementById("OatDegreeTable").style.display="none"
    document.getElementById("OatDegreeLevelTable").style.display="none"
    document.getElementById("oatCourseBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatSpecializationBtn").style.background ="rgb(249, 249, 249)"
    document.getElementById("oatDegreeBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatDegreeLevelBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatCourseBtn").style.color="White"
    document.getElementById("oatSpecializationBtn").style.color="black"
    document.getElementById("oatDegreeBtn").style.color="White"
    document.getElementById("oatDegreeLevelBtn").style.color="White"
 
    setTimeout(() => {
      setpop(false);  
      getAssignedActionA()
      document.getElementById("OatSpecializationTable").style.display="block"
      
       }, 1000);
  }
  function OpenDegree(){
    document.getElementById("OatDegreeTable").style.display="none"
    getUsersC()
    setpop(true);

    document.getElementById("OatCourseTable").style.display="none"
    document.getElementById("OatSpecializationTable").style.display="none"
   
    document.getElementById("OatDegreeLevelTable").style.display="none"
    document.getElementById("oatCourseBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatSpecializationBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatDegreeBtn").style.background ="rgb(249, 249, 249)"
    document.getElementById("oatDegreeLevelBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatCourseBtn").style.color="White"
    document.getElementById("oatSpecializationBtn").style.color="White"
    document.getElementById("oatDegreeBtn").style.color="black"
    document.getElementById("oatDegreeLevelBtn").style.color="White"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionB()
      document.getElementById("OatDegreeTable").style.display="block"
  }, 1000);
  
  }
    
      function OpenDegreeLevel(){
        document.getElementById("OatDegreeLevelTable").style.display="none"
        getUsersD()
        setpop(true);
        document.getElementById("OatCourseTable").style.display="none"
        document.getElementById("OatSpecializationTable").style.display="none"
        document.getElementById("OatDegreeTable").style.display="none"
       
        document.getElementById("oatCourseBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatSpecializationBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatDegreeBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatDegreeLevelBtn").style.background ="rgb(249, 249, 249)"
        document.getElementById("oatCourseBtn").style.color="White"
    document.getElementById("oatSpecializationBtn").style.color="White"
    document.getElementById("oatDegreeBtn").style.color="White"
    document.getElementById("oatDegreeLevelBtn").style.color="black"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionC()
      document.getElementById("OatDegreeLevelTable").style.display="block"
  }, 1000);
 
  
  }
  

      ///function Select Details


      const [Editoat, setEditoat] =useState([])
      function EditStatus(Company_Id,Status){

        SelectParticular(Company_Id)
       
        document.getElementById("ActiveEditPop").style.display = "block";
      }

      function SelectParticular(Company_Id){

        const body =
        {
          
          company_Id:Company_Id
        }
        console.log('body',body);
   
      
        axios({
               method:"POST",
               url :`${BASE_URL3}/Venture/GetParticular`,
               data:body, 
               headers: {
                    "Content-type": "application/json",
                    
                }     
            }) 
            
       
            .then((response) =>{
              console.log(JSON.stringify(response.data));
         
          
              setEditoat(response.data)
   
             
         
           })
           .catch(error => {
             console.log(error);
             
           })
      }

      function closeActiveEditForm(){

        document.getElementById("ActiveEditPop").style.display = "none";
      }

      const [Active, setActive] =useState(" ")





      ////Add Coursename

      function openForm(){

        document.getElementById("modalRegisterForm").style.display = "block";
      }
      function closeForm(){
        document.getElementById("AddErrA").innerHTML=" "
        document.getElementById("oatform").reset()
        document.getElementById("modalRegisterForm").style.display = "none";
      }
    
      function handleSubmit(){
    
        var CourseName= document.getElementById("coursename").value
    
        if(!CourseName){
    
          document.getElementById("AddErrA").innerHTML="CourseName Required"
    
        }
    
       else{
    
          document.getElementById("AddErrA").innerHTML=" "
    
        }
        if(CourseName){
        let data = {
          CourseName:CourseName
         
          
        }
       
        
        axios({
    
            method:"POST",
            url:`${BASE_URL}/OatMain/AddCourseName`,
            data,
            headers: {
              "Content-Type" : "multipart/form-data"
            }
    
        })
        .then((response) =>{
          console.log(response.data);
          
         
          if(response.data.status === "Success"){
            // toast.success("Course Added Successfully !", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            //alert("Course Added Successfully !")
            document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
             
                closeForm();
                getUsers();
             
             
              
           }
           
          else if(response.data.status === "Already Exist"){
            // toast.error("Course Name Exist", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            //alert("Course Name Exist")
            document.getElementById("CourseExist-Oat").style.display="block"
            setTimeout(() => {
             
              document.getElementById("CourseExist-Oat").style.display="none"
            }, 2000);
            
          }
       
         
        })
    .catch(error => {
      console.log(error);
      alert("Add Course failed !")
        
     
    })
    
      }
      }
    
      function handleChange(){
    
    
        var CourseName= document.getElementById("coursename").value
    
    
        if(!CourseName){
    
          document.getElementById("AddErrA").innerHTML="CourseName Required"
    
        }
    
       else{
    
          document.getElementById("AddErrA").innerHTML=" "
    
        }
      }


      ////Add Specialization 

      function openFormA(){
    
        document.getElementById("modalRegisterFormA").style.display = "block";
      }
      function closeFormA(){
        document.getElementById("AddErrB").innerHTML=" "
        document.getElementById("oatformA").reset()
        document.getElementById("modalRegisterFormA").style.display = "none";
      }
    
      function handleSubmitA(){
    
        var Specialization= document.getElementById("specialization").value
    
        if(!Specialization){
    
          document.getElementById("AddErrB").innerHTML="CategoryName Required"
    
        }
    
       else{
    
          document.getElementById("AddErrB").innerHTML=" "
    
        }
        if(Specialization){
        let data = {
          Specialization:Specialization
         
          
        }
       
        
        axios({
    
            method:"POST",
            url:`${BASE_URL}/OatMain/AddSpecialization`,
            data,
            headers: {
              "Content-Type" : "multipart/form-data"
            }
    
        })
        .then((response) =>{
          console.log(response.data);
          
         
          if(response.data.status === "Success"){
            // toast.success("Specialization Added Successfully !", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            // alert("Specialization Added Successfully !")
            document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
             
                closeFormA();
                getUsersB();
             
             
              
           }
           
          else if(response.data.status === "Already Exist"){
            // toast.error("Specialization Already Exist!", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            //alert("Specialization Already Exist!")
             
            document.getElementById("SpecializationExist-Oat").style.display="block"
            setTimeout(() => {
             
              document.getElementById("SpecializationExist-Oat").style.display="none"
            }, 2000);
          }
       
         
        })
    .catch(error => {
      console.log(error);
      alert("Add Specialization failed !")
        
     
    })
    
      }
    }
    
    
      function handleChangeA(){
    
    
        var Specialization= document.getElementById("specialization").value
    
    
        if(!Specialization){
    
          document.getElementById("AddErrB").innerHTML="Specialization Required"
    
        }
    
       else{
    
          document.getElementById("AddErrB").innerHTML=" "
    
        }
      }


      ///Add Degree

      function openFormB(){

        document.getElementById("modalRegisterFormB").style.display = "block";
      }
      function closeFormB(){
        document.getElementById("AddErrC").innerHTML=" "
        document.getElementById("oatformB").reset()
        document.getElementById("modalRegisterFormB").style.display = "none";
      }
    
      function handleSubmitB(){
    
        var Degree= document.getElementById("degree").value
    
        if(!Degree){
    
          document.getElementById("AddErrC").innerHTML="Degree Required"
    
        }
    
       else{
    
          document.getElementById("AddErrC").innerHTML=" "
    
        }
        if(Degree){
        let data = {
          Degree:Degree
         
          
        }
       
        
        axios({
    
            method:"POST",
            url:`${BASE_URL}/OatMain/AddDegree`,
            data,
            headers: {
              "Content-Type" : "multipart/form-data"
            }
    
        })
        .then((response) =>{
          console.log(response.data);
          
         
          if(response.data.status === "Success"){
            // toast.success("Degree Added Successfully !", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });
            document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
            // alert("Degree Added Successfully !")
             
                closeFormB();
                getUsersC();
              
             
              
           }
           
          else if(response.data.status === "Already Exist"){
            // toast.error("Degree Already Exist", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            //alert("Degree Already Exist")
             
            document.getElementById("DegreeExist-Oat").style.display="block"
             setTimeout(() => {
              
               document.getElementById("DegreeExist-Oat").style.display="none"
             }, 2000);
          }
       
         
        })
    .catch(error => {
      console.log(error);
      alert("Add Degreefailed !")
        
     
    })
    
      }
      }
    
      function handleChangeB(){
    
    
        var Degree= document.getElementById("degree").value
    
    
        if(!Degree){
    
          document.getElementById("AddErrC").innerHTML="Degree Required"
    
        }
    
       else{
    
          document.getElementById("AddErrC").innerHTML=" "
    
        }
      }

      ///Add DegreeLevel

      function openFormC(){
    
        document.getElementById("modalRegisterFormC").style.display = "block";
      }
      function closeFormC(){
        document.getElementById("AddErrD").innerHTML=" "
        document.getElementById("oatformC").reset()
        document.getElementById("modalRegisterFormC").style.display = "none";
      }
    
      function handleSubmitC(){
    
        var DegreeLevelName= document.getElementById("degreelevel").value
    
        if(!DegreeLevelName){
    
          document.getElementById("AddErrD").innerHTML="DegreeLevel Required"
    
        }
    
       else{
    
          document.getElementById("AddErrD").innerHTML=" "
    
        }
        if(DegreeLevelName){
        let data = {
          DegreeLevel:DegreeLevelName
         
          
        }
       
        
        axios({
    
            method:"POST",
            url:`${BASE_URL}/OatMain/AddDegreeLevel`,
            data,
            headers: {
              "Content-Type" : "multipart/form-data"
            }
    
        })
        .then((response) =>{
          console.log(response.data);
          
         
          if(response.data.status === "Success"){
            // toast.success("DegreeLevel Added Successfully !", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });

            // alert("DegreeLevel Added Successfully !")
            document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
             
                closeFormC();
                getUsersD();
    
             
              
           }
           
          else if(response.data.status === "Already Exist"){
            // toast.error("DegreeLevel Already Exist!", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });
             //alert("DegreeLevel Already Exist!")
             document.getElementById("DegreeLevelExist-Oat").style.display="block"
             setTimeout(() => {
              
               document.getElementById("DegreeLevelExist-Oat").style.display="none"
             }, 2000);
          }
       
         
        })
    .catch(error => {
      console.log(error);
      alert("Add DegreeLevel failed !")
        
     
    })
    
      }
    }
    
    
      function handleChangeC(){
    
    
        var DegreeLevelName= document.getElementById("degreelevel").value
    
    
        if(!DegreeLevelName){
    
          document.getElementById("AddErrD").innerHTML="DegreeLevel Required"
    
        }
    
       else{
    
          document.getElementById("AddErrD").innerHTML=" "
    
        }
      }
  return (
    <>

    {/* Alert Messages */}
   {/* Add success */}
    
   <div className='oat-toastpop-fade' id="AddSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Added successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
{/* Course Exist Toast */}

<div className='oat-toastpop-fade' id="CourseExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp; CourseName Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
{/* Specialization Exist Toast */}

<div className='oat-toastpop-fade' id="SpecializationExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;  Specialization Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
    {/* Degree Exist Toast */}

<div className='oat-toastpop-fade' id="DegreeExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;  Degree Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
 {/* DegreeLevel Exist Toast */}

 <div className='oat-toastpop-fade' id="DegreeLevelExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;  DegreeLevel Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
        
    <div className="oat-addgrid-layout">
    
  <div className="oat-addmain-top">
   
    <span className='OatTitle'>
    <span>EDUCATION</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OatCategory"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
   
    </div>
    </div>
      <div id="OatButton" >
           <div id="OatEntityHide">
            <button id="oatCourseBtn" onClick={OpenCoursename }>Coursename </button>
            <button id="oatSpecializationBtn" onClick={OpenSpecialization }>Specialization </button>
            <button id="oatDegreeBtn" onClick={OpenDegree}>Degree</button>
            <button id="oatDegreeLevelBtn" onClick={OpenDegreeLevel}>DegreeLevel</button>
             </div>

      </div>

      {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}


      <div id="OatCourseTable">

      <div className="oat-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD COURSENAME</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatform" onSubmit={handleSubmit} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='CourseName' onKeyUp={handleChange} id="coursename" />
         
          <span id="AddErrA" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
      <div id="OatButton" style={{marginRight:"50px"}}>
      <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="CourseBtn_Oat" onClick={openForm}><span>Add Coursename</span><i></i>
     
       </button>
       </div>
    </div>
<div id="CourseTable-Oat" style={{marginTop:"-20px"}}>

{
 allusers.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>


   <th>Id</th>
<th>CourseName</th>


{/* <th>Seen</th>
<th>Created_Date</th> */}



</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td>{e.id}</td>
          <td>{e.courseName}</td>
          
       
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
         {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDenied"></span>

   </div>
        </div>
        
      <div id="OatSpecializationTable" >

      <div className="oat-pop-fade" id="modalRegisterFormA" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SPECIALIZATION</h4>
        <button type="button" className="close" onClick={closeFormA}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatformA" onSubmit={handleSubmitA} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='Specialization' onKeyUp={handleChangeA} id="specialization" />
         
          <span id="AddErrB" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
      <div id="OatButton" style={{marginRight:"50px"}}>
      <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="SpecializationBtn_Oat" onClick={openFormA}><span>Add Specialization</span><i></i>
     
       </button>
       </div>
    </div>
        <div id="SpecializationTable-Oat" style={{marginTop:"-20px"}}>
        {
 allusersB.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
      <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th>Id</th>
<th>Specialization</th>


</tr>
</thead>
<tbody>
{paginatedPostsB.map((e,index) => {
      return<tr key={index}>
    
       
          <td>{e.id}</td>
          <td>{e.specialization}</td>
          
   
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountB==1?null: <nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationB(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
        */}
  {currentPageB >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="oatpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDeniedA"></span>

   </div>
        </div>
        <div id="OatDegreeTable">

          
        <div className="oat-pop-fade" id="modalRegisterFormB" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD DEGREE</h4>
        <button type="button" className="close" onClick={closeFormB}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatformB" onSubmit={handleSubmitB} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='DegreeLevel' onKeyUp={handleChangeB} id="degree" />
         
          <span id="AddErrC" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
        <div id="OatButton" style={{marginRight:"50px"}}>
        <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="DegreeBtn_Oat" onClick={openFormB}><span>Add Degree</span><i></i>
     
       </button>
       </div>
    </div>
   <div id="DegreeTable-Oat" style={{marginTop:"-20px"}}>
   {
  allusersC.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th>Id</th>
<th>Degree</th>


</tr>
</thead>
<tbody>
{paginatedPostsC.map((e,index) => {
      return<tr key={index}>

       
          <td>{e.id}</td>
          <td>{e.degree}</td>
         
                 
         
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountC==1?null:<nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pagesC.map((page)=>(
          <li className={
            page === currentPageC ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationC(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPageC >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousC} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageC} Of {pageCountC} 
         
            </span>   &nbsp; &nbsp;
        {currentPageC<pageCountC?<li className="page-item">
              <a class="oatpage-link" onClick={onNextC} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>)} 
  </div>
 
<div id="OatDenied">
   <span id="OatActionDeniedB"></span>

   </div>
        </div>
        <div id="OatDegreeLevelTable">

        <div className="oat-pop-fade" id="modalRegisterFormC" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD DEGREELEVEL</h4>
        <button type="button" className="close" onClick={closeFormC}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatformC" onSubmit={handleSubmitC} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='DegreeLevel' onKeyUp={handleChangeC} id="degreelevel" />
         
          <span id="AddErrD" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
        <div id="OatButton" style={{marginRight:"50px"}}>
        <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="DegreeLevelBtn_Oat" onClick={openFormC}><span>Add DegreeLevel</span><i></i>
     
       </button>
       </div>
    </div>
<div id="DegreeLevelTable-Oat" style={{marginTop:"-20px"}}>
{
 allusersD.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th>Id</th>
<th>DegreeLevel</th>


</tr>
</thead>
<tbody>
{paginatedPostsD.map((e,index) => {
      return<tr key={index}>

          <td>{e.id}</td>
          <td>{e.degreeLevel}</td>
         
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountD==1?null:<nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pagesD.map((page)=>(
          <li className={
            page === currentPageD ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationD(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPageD >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousD} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageD} Of {pageCountD} 
         
            </span>   &nbsp; &nbsp;
        {currentPageD<pageCountD?<li className="page-item">
              <a class="oatpage-link" onClick={onNextD} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDeniedC"></span>

   </div>
        </div>

      </div>
    </>
  )
}

export default OatEducationMain
